import $ from 'jquery';

$(() => {
    const $form = $('#id_eds_form');

    if ($form.length) {
        const $certs = $('#id_cert_list'),
            $sendBtn = $('#id_send_btn'),
            $sendFlBtn = $('#id_send_fl_btn'),
            $signature = $('#id_signature'),
            hash = btoa($('#id_digest').val());

        if ($sendFlBtn.length) $sendFlBtn.click(() => {
            $sendBtn.prop('disabled', true);
            $sendFlBtn.prop('disabled', true);
            $form.submit();
        });

        window.CryptoProConfig = {publicPath: './../../static/dist/'};

        const CryptoPro = require('crypto-pro');

        CryptoPro.call('isValidEDSSettings').catch(e=>alert(e));

        CryptoPro.call('getCertsList').
        then(list => {
            list.forEach(cert => {
                cert.isValid().then(()=> $certs.append($('<option>').text(cert.label).attr('value', cert.thumbprint)));
            });
            $sendBtn.removeAttr('disabled');
        }).catch(e=>alert(e)).
        then(() => {
            $sendBtn.click(() => {
                $sendBtn.prop('disabled', true);
                $sendFlBtn.prop('disabled', true);

                const thumbprint = $certs.val();
                CryptoPro.call('signData', thumbprint, hash, false).then(signature => {
                    $signature.val(signature);
                    $form.submit();
                }).catch(e=>alert(e));
            });
        });
    }
});



// WEBPACK FOOTER //
// ./js/eds/cryptopro.js